"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPropertyFilled = function IconPropertyFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.56,18.56,36,16.17V10.81a1,1,0,0,0-1-1H31a1,1,0,0,0-1,1v1.34l-4.45-3a1,1,0,0,0-1.1,0l-14,9.39a1,1,0,0,0-.45.84V40a1,1,0,0,0,1,1h6V31a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1V41H39a1,1,0,0,0,1-1V19.4A1,1,0,0,0,39.56,18.56Z",
    fill: color
  }));
};

IconPropertyFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconPropertyFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconPropertyFilled;
exports.default = _default;